<template>
  <div class="amendSignMain">
    <breadcrumb>
      <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path:'/personal/users/home' }">个人中心</el-breadcrumb-item>
        <el-breadcrumb-item>修改签约密码</el-breadcrumb-item>
      </el-breadcrumb>
    </breadcrumb>
    <div class="setSign">
      <el-form
        :model="ruleForm2"
        v-show="revisionBox"
        :rules="rules2"
        ref="ruleForm2"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="旧的签约密码：" prop="oldPwd">
          <el-input
            type="password"
            v-model="ruleForm2.oldPwd"
            autocomplete="off"
            placeholder="请您输入旧的签约密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="新的签约密码：" prop="pass">
          <el-input
            type="password"
            v-model="ruleForm2.pass"
            autocomplete="off"
            placeholder="请使用任意的6-18位密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认新的签约密码：" prop="checkPass">
          <el-input
            type="password"
            v-model="ruleForm2.checkPass"
            autocomplete="off"
            placeholder="请您再次输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="isSubmitIng" @click="submitForm('ruleForm2')">提交</el-button>
        </el-form-item>
      </el-form>
      <div class="setSuccessd textAign ft16" v-show="successBox">
        <img src="../../../../../assets/images/safety/succeed_icon.png">
        <br>签约密码修改成功
      </div>
      <div class="setSuccessd textAign ft16" v-show="defeatedBox">
        <img src="../../../../../assets/images/register/fail_icon.png">
        <br>签约密码修改失败
      </div>
    </div>
  </div>
</template>
<script>
import BaseApi from "@lib/baseApi.js";
import md5 from "@lib/encryption.js";
import breadcrumb from "@common/Breadcrumb.vue";
import {mapMutations} from "vuex"
export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value !== this.ruleForm2.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm2: {
        pass: "",
        checkPass: "",
        oldPwd: ""
      },
      isSubmitIng: false,
      rules2: {
        pass: [
          { required: true, message: "请输入新的签约密码", trigger: "blur" },
          { min: 6, max: 18, message: "签约密码为6-18位", trigger: "blur" }
        ],
        checkPass: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" }
        ],
        oldPwd: [
          { required: true, message: "请输入旧的签约密码", trigger: "blur" }
        ]
      },
      revisionBox: true,
      successBox: false,
      defeatedBox: false
    };
  },
  methods: {
    ...mapMutations(['setUpdateUserState']),
    submitForm(formName) {
      this.isSubmitIng = true;
      this.$refs[formName].validate(valid => {
        if (valid) {
          var queryStr = {
            handleType: "2",
            newPwd: md5.md5(this.ruleForm2.pass),
            oldPwd: md5.md5(this.ruleForm2.oldPwd)
          };
          BaseApi.createRpcToken("/user/updatePwd", queryStr, "post")
            .then(
              data => {
                this.revisionBox = false;
                this.successBox = true;
                this.setUpdateUserState("updateSignPwd")
                setTimeout(() => {
                  this.$router.push({
                    path: "/personal/users/home"
                  });
                  this.isSubmitIng = false;
                }, 2000);
              },
              data => {
                // this.revisionBox = false;
                // this.defeatedBox = true;
                // setTimeout(() => {
                //   this.$router.push({
                //     path: "/personal/users/home"
                //   });
                // }, 2000);
                this.isSubmitIng = false;
              }
            )
            .catch(function(e) {
              errorLog(e);
            });
        } else {
          this.isSubmitIng = false;
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  components: {
    breadcrumb
  }
};
</script>
<style lang="scss">
.amendSignMain {
  padding: 20px;
  box-sizing: border-box;
  .setSign {
    position: relative;
    width: 100%;
    height: 100%;
    .el-form {
      position: absolute;
      display: table;
      width: 440px;
      height: 228px;
      left: 50%;
      top: 50%;
      margin-top: -114px;
      margin-left: -214px;
      .el-input__inner {
        width: 300px;
        height: 30px;
        .el-form-item__label {
          width: 126px;
          font-size: 14px;
          color: #969696;
        }
      }
      .el-form-item__content {
        float: left;
        margin: 0 !important;
        .el-button--primary {
          width: 160px;
          height: 36px;
          margin-left: 141px;
          background: #D81212;
          border: none;
        }
        .el-button--primary:hover {
          background: #a5303d;
        }
      }
      .el-form-item__label {
        width: 140px !important;
        float: left;
        margin: 0;
        font-family: "PingFangSC-Medium";
        font-size: 14px;
        color: #969696;
        text-align: right;
        padding-right: 0;
      }
    }
    .setSuccessd {
      width: 100%;
      position: absolute;
      height: 100px;
      top: 50%;
      margin-top: -50px;
      text-align: center;
      color: #505050;
      font-family: "PingFangSC-Medium";
      img {
        margin-bottom: 10px;
      }
    }
  }
}
</style>


